<script>
import AppForm from '../components/AppForm';
import getFieldErrors from '../getFieldErrors';
import SubLoader from '../components/SubLoader';

export default {
  name: 'SignatureEvrotrust',
  components: {
    AppForm,
    SubLoader,
  },
  data() {
    return {
      fieldErrors: {},
      evroTransactionId: null,
      authProcess: {},
    }
  },
  computed: {
    inputValues() {
      return this.$root.$options.storeGetters.inputValues();
    },
    callingCode() {
      return this.$root.$options.storeGetters.callingCode();
    },
    additionalMethodConfig() {
      return this.$root.$options.storeGetters.additionalMethodConfig();
    },
    schema() {
      return [
        {
          type: 'text',
          name: 'idcode',
          label: this.$t('idcode'),
        },
        {
          type: 'sectionSpacer',
          text: this.$t('or') + ':',
        },
        {
          type: 'tel',
          name: 'phone',
          label: this.$t('phone-number'),
          callingCode: this.callingCode,
        },
        {
          type: 'sectionSpacer',
          text: this.$t('or') + ':',
        },
        {
          type: 'email',
          name: 'email',
          label: this.$t('email'),
        },
        {
          type: 'submit',
          label: this.$t('Sign')
        }
      ]
    },
    formValue: {
      get() {
        return {
          idcode: this.inputValues.idcode,
          email: this.inputValues.email,
          phone: this.inputValues.phone,
        }
      },
      set(newValues) {
        this.updateInputValues(newValues);
      }
    },
  },
  methods: {
    updateInputValues(newValues) {
      this.$root.$options.storeActions.updateInputValues(newValues);
    },
    loadingStart() {
      this.$root.$options.storeActions.loadingStart();
    },
    loadingEnd() {
      this.$root.$options.storeActions.loadingEnd();
    },
    addFlashMessage(message) {
      this.$root.$options.storeActions.addFlashMessage(message);
    },
    clearFlashMessages() {
      this.$root.$options.storeActions.clearFlashMessages();
    },
    startSignatureProcessing() {
      this.$root.$options.storeActions.startSignatureProcessing();
    },
    endSignatureProcessing() {
      this.$root.$options.storeActions.endSignatureProcessing();
    },
    clearErrors() {
      this.fieldErrors = {};
    },
    cancel() {
      const {cancel} = this.authProcess;
      if (cancel) {
        cancel();
      }
    },
    sign() {
      this.loadingStart();
      this.clearFlashMessages();
      this.clearErrors();

      const dataToSubmit = {
        ...this.formValue,
      };
      dataToSubmit.phone = dataToSubmit.phone ? this.callingCode + dataToSubmit.phone : '';
      const additionalMethodConfig = this.additionalMethodConfig || {};
      this.authProcess = this.$root.$options.eidEasyClient.signature.evroTrustSignature.start({
        ...dataToSubmit,
        started: (result) => {
          if (result.data && result.data.transaction_id) {
            this.evroTransactionId = result.data.transaction_id;
            this.loadingEnd();
            this.startSignatureProcessing();
          }
        },
        fail: (error) => {
          if (!error.isCancel) {
            this.addFlashMessage(error);
          }
          this.fieldErrors = getFieldErrors(error);
          this.$root.$options.eidEasyOnFail(error);
        },
        success: (result) => {
          this.$root.$options.eidEasyOnSuccess(result);
        },
        finished: () => {
          this.evroTransactionId = undefined;
          this.endSignatureProcessing();
          this.loadingEnd();
        },
        ...additionalMethodConfig,
      });
    }
  },
}
</script>

<template>
  <div :class="$style.formContainer">
    <div
      v-if="evroTransactionId"
      :class="$style.challenge"
    >
      <SubLoader>
        <div>{{ $t('sign-in-evrotrust-app') }}</div>
        <div :class="$style.label">
          {{ $t('transaction-id') }}
        </div>
        <div :class="$style.highlight">
          {{ evroTransactionId }}
        </div>
      </SubLoader>
    </div>
    <div v-else>
      <AppForm
        id="smartIdSignatureForm"
        v-model="formValue"
        :schema="schema"
        :on-submit="sign"
        :errors="fieldErrors"
      />
    </div>
  </div>
</template>

<style lang="scss" module>
.formContainer {
  max-width: $form-container-width;
  margin: 0 auto;
}

.label {
  color: $gray-600;
  margin-top: $spacer-6;
}

.highlight {
  font-weight: $font-weight-bold;
  font-size: $font-size-xl;
}

</style>
